import React, { memo, useMemo } from "react";
import { connect } from "react-redux";
import { mergeReloadStopsToMainRoute } from "../../utils/helpers";
import Markers from "./Markers";

function propsEqual(p, n) {
  return p.hoverStop?.id === n.hoverStop?.id && p.editId === n.editId;
}

function HoverMarker({
  hoverStop,
  solution,
  mapRef,
  fullRoutes,
  isReloadAllowed
}) {
  const routes = useMemo(() => {
    if (hoverStop?.routeName) {
      return mergeReloadStopsToMainRoute(solution.routes);
    } else {
      return fullRoutes;
    }
  }, [hoverStop]);

  let index = false;
  const route =
    solution &&
    hoverStop &&
    routes.find((route, i) => {
      if (
        route.id === hoverStop.routeId ||
        route.route_name === hoverStop?.routeName
      ) {
        index = i;
        return true;
      }
      return false;
    });

  let count = 0;

  if (index !== false) {
    for (let i = 0; i < route.stops.length; i++) {
      if (
        route.stops[i].type !== "start" &&
        route.stops[i].type !== "end" &&
        route.stops[i].type !== "break" &&
        route.stops[i].type !== "reload"
      ) {
        count++;
      }
      if (route.stops[i].id === hoverStop.stop.id) {
        break;
      }
    }
  }

  return hoverStop ? (
    <Markers
      markers={[hoverStop.stop]}
      routeIndex={Number.isInteger(index) ? index : -1}
      isHover={true}
      mapRef={mapRef}
      customCount={count}
      snapToRoad={hoverStop.snapToRoad}
      endLocationDefined={route && route.end_location_defined !== false}
      routeStatus={route && route.status}
      routeId={hoverStop.routeId}
      index={route && route.index}
    />
  ) : null;
}

const mapStateToProps = state => ({
  solution: state.project.solution,
  hoverStop: state.map.hoverStop,
  editId: state.extendable.type === "stops" && state.extendable.id,
  isReloadAllowed: state.project.vrp.configuration.allow_reload
});

export default memo(connect(mapStateToProps, {})(HoverMarker), propsEqual);
